import { BankType, EWalletProviderType } from "@/enums/enums";
import { i18n } from "@/i18n";

export function BankReferenceList(languageType: string) {
  return languageType == "th"
    ? [
        {
          bankId: 1,
          logoFilePath: "peakengine/Content/Image/BankLogo/BBL.png",
          bankShortName: "ธ.กรุงเทพ",
          bankFullName: "ธนาคารกรุงเทพ จำกัด (มหาชน)",
        },
        {
          bankId: 2,
          logoFilePath: "peakengine/Content/Image/BankLogo/KBANK.png",
          bankShortName: "ธ.กสิกรไทย",
          bankFullName: "ธนาคารกสิกรไทย จำกัด (มหาชน)",
        },
        {
          bankId: 3,
          logoFilePath: "peakengine/Content/Image/BankLogo/SCB.png",
          bankShortName: "ธ.ไทยพาณิชย์",
          bankFullName: "ธนาคารไทยพาณิชย์ จำกัด (มหาชน)",
        },
        {
          bankId: 4,
          logoFilePath: "peakengine/Content/Image/BankLogo/SME.png",
          bankShortName: "ธ.เอชเอ็มอี",
          bankFullName: "ธนาคารพัฒนาวิสาหกิจขนาดกลางและขนาดย่อมแห่งประเทศไทย",
        },
        {
          bankId: 5,
          logoFilePath: "peakengine/Content/Image/BankLogo/KTB.png",
          bankShortName: "ธ.กรุงไทย",
          bankFullName: "ธนาคารกรุงไทย จำกัด (มหาชน)",
        },
        {
          bankId: 6,
          logoFilePath: "peakengine/Content/Image/BankLogo/BAY.png",
          bankShortName: "ธ.กรุงศรี",
          bankFullName: "ธนาคารกรุงศรีอยุธยา จำกัด (มหาชน)",
        },
        {
          bankId: 7,
          logoFilePath: "peakengine/Content/Image/BankLogo/KKP.png",
          bankShortName: "ธ.เกียรตินาคินภัทร",
          bankFullName: "ธนาคารเกียรตินาคินภัทร จำกัด (มหาชน)",
        },
        {
          bankId: 8,
          logoFilePath: "peakengine/Content/Image/BankLogo/CIMB.png",
          bankShortName: "ธ.ซีไอเอ็มบี",
          bankFullName: "ธนาคารซีไอเอ็มบี ไทย จำกัด (มหาชน)",
        },
        {
          bankId: 9,
          logoFilePath: "peakengine/Content/Image/BankLogo/TTB.png",
          bankShortName: "ธ.ทหารไทยธนชาต",
          bankFullName: "ธนาคารทหารไทยธนชาต จำกัด (มหาชน)",
        },
        {
          bankId: 10,
          logoFilePath: "peakengine/Content/Image/BankLogo/TISCO.png",
          bankShortName: "ธ.ทิสโก้",
          bankFullName: "ธนาคารทิสโก้ จำกัด (มหาชน)",
        },
        {
          bankId: 11,
          logoFilePath: "peakengine/Content/Image/BankLogo/TCR.png",
          bankShortName: "ธ.ไทยเครดิต",
          bankFullName: "ธนาคารไทยเครดิต เพื่อรายย่อย จำกัด (มหาชน)",
        },
        {
          bankId: 12,
          logoFilePath: "peakengine/Content/Image/BankLogo/TCAP.png",
          bankShortName: "ธ.ธนชาต",
          bankFullName: "ธนาคารธนชาต จำกัด (มหาชน)",
        },
        {
          bankId: 13,
          logoFilePath: "peakengine/Content/Image/BankLogo/BAAC.png",
          bankShortName: "ธ.ธกส.",
          bankFullName: "ธนาคารเพื่อการเกษตรและสหกรณ์การเกษตร",
        },
        {
          bankId: 14,
          logoFilePath: "peakengine/Content/Image/BankLogo/EXIM.png",
          bankShortName: "ธ.ธสน.",
          bankFullName: "ธนาคารเพื่อการส่งออกและนำเข้าแห่งประเทศไทย",
        },
        {
          bankId: 15,
          logoFilePath: "peakengine/Content/Image/BankLogo/UOB.png",
          bankShortName: "ธ.ยูโอบี",
          bankFullName: "ธนาคารยูโอบี จำกัด (มหาชน)",
        },
        {
          bankId: 16,
          logoFilePath: "peakengine/Content/Image/BankLogo/LHBANK.png",
          bankShortName: "ธ.แลนด์ แอนด์ เฮ้าส์",
          bankFullName: "ธนาคารแลนด์ แอนด์ เฮ้าส์ จำกัด (มหาชน)",
        },
        {
          bankId: 17,
          logoFilePath: "peakengine/Content/Image/BankLogo/SCBT.png",
          bankShortName: "ธ.สแตนดาร์ด",
          bankFullName: "ธนาคารสแตนดาร์ดชาร์เตอร์ด (ไทย) จำกัด (มหาชน)",
        },
        {
          bankId: 18,
          logoFilePath: "peakengine/Content/Image/BankLogo/GSB.png",
          bankShortName: "ธ.ออมสิน",
          bankFullName: "ธนาคารออมสิน",
        },
        {
          bankId: 20,
          logoFilePath: "peakengine/Content/Image/BankLogo/ISBT.png",
          bankShortName: "ธ.อิสลาม",
          bankFullName: "ธนาคารอิสลามแห่งประเทศไทย",
        },
        {
          bankId: 21,
          logoFilePath: "peakengine/Content/Image/BankLogo/ICBC.png",
          bankShortName: "ธ.ไอซีบีซี",
          bankFullName: "ธนาคารไอซีบีซี (ไทย) จำกัด (มหาชน)",
        },
        {
          bankId: 22,
          logoFilePath: "peakengine/Content/Image/BankLogo/JPMCB.png",
          bankShortName: "ธ.เจพีมอร์แกน",
          bankFullName: "ธนาคารเจพีมอร์แกน เชส",
        },
        {
          bankId: 23,
          logoFilePath: "peakengine/Content/Image/BankLogo/CITIBANK.png",
          bankShortName: "ธ.ซิตี้แบงก์",
          bankFullName: "ธนาคารซิตี้แบงก์ เอ็น.เอ.",
        },
        {
          bankId: 24,
          logoFilePath: "peakengine/Content/Image/BankLogo/SMBC.png",
          bankShortName: "ธ.ซูมิโตโม",
          bankFullName: "ธนาคารซูมิโตโม มิตซุย แบงกิ้ง คอร์ปอเรชั่น",
        },
        {
          bankId: 25,
          logoFilePath: "peakengine/Content/Image/BankLogo/DBBK.png",
          bankShortName: "ธ.ดอยซ์แบงก์",
          bankFullName: "ธนาคารดอยซ์แบงก์",
        },
        {
          bankId: 26,
          logoFilePath: "peakengine/Content/Image/BankLogo/BNPP.png",
          bankShortName: "ธ.บีเอ็นพี",
          bankFullName: "ธนาคารบีเอ็นพี พารีบาส์",
        },
        {
          bankId: 27,
          logoFilePath: "peakengine/Content/Image/BankLogo/MIZUHO.png",
          bankShortName: "ธ.มิซูโฮ",
          bankFullName: "ธนาคารมิซูโฮ จำกัด สาขากรุงเทพฯ",
        },
        {
          bankId: 28,
          logoFilePath: "peakengine/Content/Image/BankLogo/Mega.png",
          bankShortName: "ธ.เมกะสากล",
          bankFullName: "ธนาคารเมกะ สากลพาณิชย์ จำกัด (มหาชน)",
        },
        {
          bankId: 29,
          logoFilePath: "peakengine/Content/Image/BankLogo/BOC.png",
          bankShortName: "ธ.แห่งประเทศจีน",
          bankFullName: "ธนาคารแห่งประเทศจีน (ไทย) จำกัด (มหาชน)",
        },
        {
          bankId: 30,
          logoFilePath: "peakengine/Content/Image/BankLogo/BOA.png",
          bankShortName: "ธ.แห่งอเมริกา",
          bankFullName: "ธนาคารแห่งอเมริกาเนชั่นแนลแอสโซซิเอชั่น",
        },
        {
          bankId: 31,
          logoFilePath: "peakengine/Content/Image/BankLogo/SMTB.png",
          bankShortName: "ธ.เอสเอ็มทีบี",
          bankFullName: "ธนาคารซูมิโตโม มิตซุย ทรัสต์ (ไทย) จำกัด (มหาชน)",
        },
        {
          bankId: 32,
          logoFilePath: "peakengine/Content/Image/BankLogo/RHB.png",
          bankShortName: "ธ.อาร์ เอช บี",
          bankFullName: "ธนาคารอาร์ เอช บี จำกัด",
        },
        {
          bankId: 33,
          logoFilePath: "peakengine/Content/Image/BankLogo/Indian.png",
          bankShortName: "ธ.ไอโอบี",
          bankFullName: "ธนาคารอินเดียนโอเวอร์ซีส์",
        },
        {
          bankId: 34,
          logoFilePath: "peakengine/Content/Image/BankLogo/HSBC.png",
          bankShortName: "ธ.เอชเอสบีซี",
          bankFullName: "ธนาคารฮ่องกงและเซี่ยงไฮ้แบงกิ้งคอร์ปอเรชั่น จำกัด",
        },
        {
          bankId: 35,
          logoFilePath: "peakengine/Content/Image/BankLogo/ANZ.png",
          bankShortName: "ธ.เอเอ็นแซด",
          bankFullName: "ธนาคารเอเอ็นแซด (ไทย) จำกัด (มหาชน)",
        },
        {
          bankId: 36,
          logoFilePath: "peakengine/Content/Image/BankLogo/OCBC.png",
          bankShortName: "ธ.โอเวอร์ซี",
          bankFullName: "ธนาคารโอเวอร์ซี-ไชนีสแบงกิ้งคอร์ปอเรชั่น จำกัด",
        },
        {
          bankId: 37,
          logoFilePath: "peakengine/Content/Image/BankLogo/GHBANK.png",
          bankShortName: "ธ.อาคารสงเคราะห์",
          bankFullName: "ธนาคารอาคารสงเคราะห์",
        },
        {
          bankId: 0,
          logoFilePath: "peakengine/Content/Image/BankLogo/OTHER.png",
          bankShortName: "ธ.อื่นๆ",
          bankFullName: "อื่นๆ",
        },
      ]
    : [
        {
          bankId: 1,
          logoFilePath: "peakengine/Content/Image/BankLogo/BBL.png",
          bankShortName: "BBL",
          bankFullName: "BANGKOK BANK PUBLIC COMPANY LTD.",
        },
        {
          bankId: 2,
          logoFilePath: "peakengine/Content/Image/BankLogo/KBANK.png",
          bankShortName: "KBANK",
          bankFullName: "KASIKORNBANK PUBLIC COMPANY LIMITED",
        },
        {
          bankId: 3,
          logoFilePath: "peakengine/Content/Image/BankLogo/SCB.png",
          bankShortName: "SCB",
          bankFullName: "SIAM COMMERCIAL BANK PUBLIC COMPANY LTD.",
        },
        {
          bankId: 4,
          logoFilePath: "peakengine/Content/Image/BankLogo/SME.png",
          bankShortName: "SME",
          bankFullName: "SMALL AND MEDIUM ENTERPRISE DEVELOPMENT BANK OF THAILAND",
        },
        {
          bankId: 5,
          logoFilePath: "peakengine/Content/Image/BankLogo/KTB.png",
          bankShortName: "KTB",
          bankFullName: "KRUNG THAI BANK PUBLIC COMPANY LTD.",
        },
        {
          bankId: 6,
          logoFilePath: "peakengine/Content/Image/BankLogo/BAY.png",
          bankShortName: "BAY",
          bankFullName: "BANK OF AYUDHYA PUBLIC COMPANY LTD.",
        },
        {
          bankId: 7,
          logoFilePath: "peakengine/Content/Image/BankLogo/KK.png",
          bankShortName: "KK",
          bankFullName: "KIATNAKIN PHATRA BANK PUBLIC COMPANY LIMITED",
        },
        {
          bankId: 8,
          logoFilePath: "peakengine/Content/Image/BankLogo/CIMB.png",
          bankShortName: "CIMBT",
          bankFullName: "CIMB THAI BANK Public Company Limited",
        },
        {
          bankId: 9,
          logoFilePath: "peakengine/Content/Image/BankLogo/TTB.png",
          bankShortName: "TMBTHANACHART",
          bankFullName: "TMBTHANACHART BANK PUBLIC COMPANY LIMITED",
        },
        {
          bankId: 10,
          logoFilePath: "peakengine/Content/Image/BankLogo/TISCO.png",
          bankShortName: "TISCO",
          bankFullName: "TISCO BANK PUBLIC COMPANY LIMITED",
        },
        {
          bankId: 11,
          logoFilePath: "peakengine/Content/Image/BankLogo/TCR.png",
          bankShortName: "TCR",
          bankFullName: "THE THAI CREDIT RETAIL BANK PUBLIC COMPANY LIMITED",
        },
        {
          bankId: 12,
          logoFilePath: "peakengine/Content/Image/BankLogo/TCAP.png",
          bankShortName: "TBANK",
          bankFullName: "THANACHART BANK PUBLIC COMPANY LTD.",
        },
        {
          bankId: 13,
          logoFilePath: "peakengine/Content/Image/BankLogo/BAAC.png",
          bankShortName: "BAAC",
          bankFullName: "BANK FOR AGRICULTURE AND AGRICULTURAL COOPERATIVES",
        },
        {
          bankId: 14,
          logoFilePath: "peakengine/Content/Image/BankLogo/EXIM.png",
          bankShortName: "EXIM",
          bankFullName: "EXPORT-IMPORT BANK OF THAILAND",
        },
        {
          bankId: 15,
          logoFilePath: "peakengine/Content/Image/BankLogo/UOB.png",
          bankShortName: "UOBT",
          bankFullName: "UNITED OVERSEAS BANK (THAI) PUBLIC COMPANY LIMITED",
        },
        {
          bankId: 16,
          logoFilePath: "peakengine/Content/Image/BankLogo/LHBANK.png",
          bankShortName: "LHBANK",
          bankFullName: "LAND AND HOUSES BANK PUBLIC COMPANY LIMITED",
        },
        {
          bankId: 17,
          logoFilePath: "peakengine/Content/Image/BankLogo/SCBT.png",
          bankShortName: "SCBT",
          bankFullName: "STANDARD CHARTERED BANK (THAI) PUBLIC COMPANY LIMITED",
        },
        {
          bankId: 18,
          logoFilePath: "peakengine/Content/Image/BankLogo/GSB.png",
          bankShortName: "GSB",
          bankFullName: "GOVERNMENT SAVINGS BANK",
        },
        {
          bankId: 20,
          logoFilePath: "peakengine/Content/Image/BankLogo/ISBT.png",
          bankShortName: "ISBT",
          bankFullName: "ISLAMIC BANK OF THAILAND",
        },
        {
          bankId: 21,
          logoFilePath: "peakengine/Content/Image/BankLogo/ICBC.png",
          bankShortName: "ICBCT",
          bankFullName: "INDUSTRIAL AND COMMERCIAL BANK OF CHINA (THAI) PUBLIC COMPANY LIMITED",
        },
        {
          bankId: 22,
          logoFilePath: "peakengine/Content/Image/BankLogo/JPMCB.png",
          bankShortName: "JPMCB",
          bankFullName: "JPMORGAN CHASE BANK, NATIONAL ASSOCIATION",
        },
        {
          bankId: 23,
          logoFilePath: "peakengine/Content/Image/BankLogo/CITIBANK.png",
          bankShortName: "CITI",
          bankFullName: "CITIBANK, N.A.",
        },
        {
          bankId: 24,
          logoFilePath: "peakengine/Content/Image/BankLogo/SMBC.png",
          bankShortName: "SMBC",
          bankFullName: "SUMITOMO MITSUI BANKING CORPORATION",
        },
        {
          bankId: 25,
          logoFilePath: "peakengine/Content/Image/BankLogo/DBBK.png",
          bankShortName: "DBBK",
          bankFullName: "DEUTSCHE BANK AG.",
        },
        {
          bankId: 26,
          logoFilePath: "peakengine/Content/Image/BankLogo/BNPP.png",
          bankShortName: "BNPP",
          bankFullName: "BNP PARIBAS",
        },
        {
          bankId: 27,
          logoFilePath: "peakengine/Content/Image/BankLogo/MIZUHO.png",
          bankShortName: "MIZUHO",
          bankFullName: "Mizuho Bank, Ltd. Bangkok Branch",
        },
        {
          bankId: 28,
          logoFilePath: "peakengine/Content/Image/BankLogo/Mega.png",
          bankShortName: "Mega",
          bankFullName: "MEGA INTERNATIONAL COMMERCIAL BANK PUBLIC COMPANY LIMITED",
        },
        {
          bankId: 29,
          logoFilePath: "peakengine/Content/Image/BankLogo/BOC.png",
          bankShortName: "BOC",
          bankFullName: "BANK OF CHINA (THAI) PUBLIC COMPANY LIMITED",
        },
        {
          bankId: 30,
          logoFilePath: "peakengine/Content/Image/BankLogo/BOA.png",
          bankShortName: "BofA",
          bankFullName: "BANK OF AMERICA, NATIONAL ASSOCIATION",
        },
        {
          bankId: 31,
          logoFilePath: "peakengine/Content/Image/BankLogo/SMTB.png",
          bankShortName: "SMTB",
          bankFullName: "SUMITOMO MITSUI TRUST BANK (THAI) PUBLIC COMPANY LIMITED",
        },
        {
          bankId: 32,
          logoFilePath: "peakengine/Content/Image/BankLogo/RHB.png",
          bankShortName: "RHB",
          bankFullName: "RHB BANK BERHAD",
        },
        {
          bankId: 33,
          logoFilePath: "peakengine/Content/Image/BankLogo/Indian.png",
          bankShortName: "Indian",
          bankFullName: "INDIAN OVERSEA BANK",
        },
        {
          bankId: 34,
          logoFilePath: "peakengine/Content/Image/BankLogo/HSBC.png",
          bankShortName: "HSBC",
          bankFullName: "THE HONGKONG AND SHANGHAI BANKING CORPORATION LTD.",
        },
        {
          bankId: 35,
          logoFilePath: "peakengine/Content/Image/BankLogo/ANZ.png",
          bankShortName: "ANZ",
          bankFullName: "ANZ BANK (THAI) PUBLIC COMPANY LIMITED",
        },
        {
          bankId: 36,
          logoFilePath: "peakengine/Content/Image/BankLogo/OCBC.png",
          bankShortName: "OCBC",
          bankFullName: "OVER SEA-CHINESE BANKING CORPORATION LIMITED",
        },
        {
          bankId: 37,
          logoFilePath: "peakengine/Content/Image/BankLogo/GHBANK.png",
          bankShortName: "GHB",
          bankFullName: "THE GOVERNMENT HOUSING BANK",
        },
        {
          bankId: 0,
          logoFilePath: "peakengine/Content/Image/BankLogo/OTHER.png",
          bankShortName: "Other",
          bankFullName: "Other",
        },
      ];
}

export function GetEWalletProviderList() {
  return [
    {
      eWalletProviderTypeId: EWalletProviderType.Wallet2C2P,
      logoFilePath: "peakengine/Content/Image/EwalletLogo/2C2P.png",
      eWalletName: "2C2P",
    },
    {
      eWalletProviderTypeId: EWalletProviderType.WalletOmise,
      logoFilePath: "peakengine/Content/Image/EwalletLogo/Omise.png",
      eWalletName: "Omise",
    },
    {
      eWalletProviderTypeId: EWalletProviderType.TrueWallet,
      logoFilePath: "peakengine/Content/Image/EwalletLogo/TrueWallet.png",
      eWalletName: "True Wallet",
    },
    {
      eWalletProviderTypeId: EWalletProviderType.LinePayWepay,
      logoFilePath: "peakengine/Content/Image/EwalletLogo/LinePay.png",
      eWalletName: "LINE Pay/wePAY",
    },
    {
      eWalletProviderTypeId: EWalletProviderType.Paypal,
      logoFilePath: "peakengine/Content/Image/EwalletLogo/PayPal.png",
      eWalletName: "PayPal",
    },
    {
      eWalletProviderTypeId: EWalletProviderType.PaySolutions,
      logoFilePath: "peakengine/Content/Image/EwalletLogo/PaySoltion.png",
      eWalletName: "Pay Solutions",
    },
    {
      eWalletProviderTypeId: EWalletProviderType.xendit,
      logoFilePath: "peakengine/Content/Image/EwalletLogo/Xendit.png",
      eWalletName: "xendit",
    },
    {
      eWalletProviderTypeId: EWalletProviderType.WalletLazada,
      logoFilePath: "peakengine/Content/Image/EwalletLogo/Lazada.png",
      eWalletName: "Lazada",
    },
    {
      eWalletProviderTypeId: EWalletProviderType.WalletShopee,
      logoFilePath: "peakengine/Content/Image/EwalletLogo/Shopee.png",
      eWalletName: "Shopee",
    },
    {
      eWalletProviderTypeId: EWalletProviderType.WalletJD,
      logoFilePath: "peakengine/Content/Image/EwalletLogo/JD.png",
      eWalletName: "JD.com",
    },
    {
      eWalletProviderTypeId: EWalletProviderType.Grab,
      logoFilePath: "peakengine/Content/Image/EwalletLogo/Grab.png",
      eWalletName: "Grab",
    },
    {
      eWalletProviderTypeId: EWalletProviderType.FoodPanda,
      logoFilePath: "peakengine/Content/Image/EwalletLogo/FoodPanda.png",
      eWalletName: "foodpanda",
    },
    {
      eWalletProviderTypeId: EWalletProviderType.LineMan,
      logoFilePath: "peakengine/Content/Image/EwalletLogo/LineMan.png",
      eWalletName: "LINE MAN",
    },
    {
      eWalletProviderTypeId: EWalletProviderType.Lalamove,
      logoFilePath: "peakengine/Content/Image/EwalletLogo/Lalamove.png",
      eWalletName: "Lalamove",
    },
    {
      eWalletProviderTypeId: EWalletProviderType.Robinhood,
      logoFilePath: "peakengine/Content/Image/EwalletLogo/Robinhood.png",
      eWalletName: "Robinhood",
    },
    {
      eWalletProviderTypeId: EWalletProviderType.BigThailand,
      logoFilePath: "peakengine/Content/Image/EwalletLogo/BigThailand.png",
      eWalletName: "BigThailand",
    },
    {
      eWalletProviderTypeId: EWalletProviderType.Stripe,
      logoFilePath: "peakengine/Content/Image/EwalletLogo/Stripe.png",
      eWalletName: "Stripe",
    },
    {
      eWalletProviderTypeId: EWalletProviderType.Payoneer,
      logoFilePath: "peakengine/Content/Image/EwalletLogo/Payoneer.png",
      eWalletName: "Payoneer",
    },
    {
      eWalletProviderTypeId: EWalletProviderType.BeamWallet,
      logoFilePath: "peakengine/Content/Image/EwalletLogo/Beam.png",
      eWalletName: "Beam wallet",
    },
    {
      eWalletProviderTypeId: EWalletProviderType.TikTokShop,
      logoFilePath: "peakengine/Content/Image/EwalletLogo/TiktokShop.png",
      eWalletName: "TikTok Shop",
    },
    {
      eWalletProviderTypeId: EWalletProviderType.mPay,
      logoFilePath: "peakengine/Content/Image/EwalletLogo/mPay.png",
      eWalletName: "mPay",
    },
    {
      eWalletProviderTypeId: EWalletProviderType.HDmall,
      logoFilePath: "peakengine/Content/Image/EwalletLogo/HDmall.png",
      eWalletName: "HDmall",
    },
    {
      eWalletProviderTypeId: EWalletProviderType.WalletAtPost,
      logoFilePath: "peakengine/Content/Image/EwalletLogo/Wallet@Post.png",
      eWalletName: "Wallet@Post",
    },
    {
      eWalletProviderTypeId: EWalletProviderType.Beam,
      logoFilePath: "peakengine/Content/Image/EwalletLogo/newBeam.jpg",
      eWalletName: "Beam",
    },
    {
      eWalletProviderTypeId: EWalletProviderType.ChillPay,
      logoFilePath: "peakengine/Content/Image/EwalletLogo/ChillPay.png",
      eWalletName: "ChillPay",
    },
    {
      eWalletProviderTypeId: EWalletProviderType.OneTwoThreeService,
      logoFilePath: "peakengine/Content/Image/EwalletLogo/123Service.png",
      eWalletName: "123Service",
    },
    {
      eWalletProviderTypeId: EWalletProviderType.NocNoc,
      logoFilePath: "peakengine/Content/Image/EwalletLogo/NocNoc.png",
      eWalletName: "NocNoc",
    },
    {
      eWalletProviderTypeId: EWalletProviderType.MoneySpace,
      logoFilePath: "peakengine/Content/Image/EwalletLogo/MoneySpace.png",
      eWalletName: "Money Space",
    },
    {
      eWalletProviderTypeId: EWalletProviderType.LINEShopping,
      logoFilePath: "peakengine/Content/Image/EwalletLogo/LINEShopping.png",
      eWalletName: "LINE Shopping",
    },
    {
      eWalletProviderTypeId: EWalletProviderType.Alipay,
      logoFilePath: "peakengine/Content/Image/EwalletLogo/Alipay.png",
      eWalletName: "Alipay",
    },
    {
      eWalletProviderTypeId: EWalletProviderType.xplORe,
      logoFilePath: "peakengine/Content/Image/EwalletLogo/xplORe.png",
      eWalletName: "xplORe Wallet",
    },
    {
      eWalletProviderTypeId: EWalletProviderType.T2PWallet,
      logoFilePath: "peakengine/Content/Image/EwalletLogo/T2PWallet.png",
      eWalletName: "T2P Wallet",
    },
    {
      eWalletProviderTypeId: EWalletProviderType.Meta,
      logoFilePath: "peakengine/Content/Image/EwalletLogo/Meta.png",
      eWalletName: "Meta",
    },
    {
      eWalletProviderTypeId: EWalletProviderType.GoogleAds,
      logoFilePath: "peakengine/Content/Image/EwalletLogo/GoogleAds.png",
      eWalletName: "Google Ads",
    },
  ];
}

export function GetBankReferenceHelper(bankReferenceId: number) {
  const bankReference = {
    imgUrl: "",
    name: "",
  };
  const bankReferenceList = BankReferenceList(i18n.locale);
  const selectBankReference = bankReferenceList.find((x: any) => x.bankId == bankReferenceId);
  if (selectBankReference) {
    bankReference.name = selectBankReference.bankShortName;
    bankReference.imgUrl = process.env.VUE_APP_PeakBlobStorage.UrlCombine(selectBankReference.logoFilePath);
  }
  return bankReference;
}

export function GetEWalletProviderHelper(eWalletProviderId: EWalletProviderType) {
  const eWalletProvider = {
    imgUrl: "",
    name: "",
  };
  const eWalletProviderList = GetEWalletProviderList();
  const selectEWalletProvider = eWalletProviderList.find((x: any) => x.eWalletProviderTypeId == eWalletProviderId);
  if (selectEWalletProvider) {
    eWalletProvider.name = selectEWalletProvider.eWalletName;
    eWalletProvider.imgUrl = process.env.VUE_APP_PeakBlobStorage.UrlCombine(selectEWalletProvider.logoFilePath);
  }
  return eWalletProvider;
}

export function GetBankTypeHelper(bankAccountType: BankType) {
  let bankType: any = "";
  switch (bankAccountType) {
    case BankType.CurrentAccount:
      bankType = i18n.t("Current");
      break;
    case BankType.SavingAccount:
      bankType = i18n.t("Saving");
      break;
    case BankType.FixedDeposit:
      bankType = i18n.t("Fixed");
      break;
  }
  return bankType;
}

export function GetBankAccountType(bankAccountType: BankType) {
  switch (bankAccountType) {
    case BankType.CurrentAccount:
      return i18n.t("Current_Account");
    case BankType.SavingAccount:
      return i18n.t("Saving_Account");
    case BankType.FixedDeposit:
      return i18n.t("Fixed_Deposit");
    default:
      return "";
  }
}
